import { render, staticRenderFns } from "./pk-session-table.vue?vue&type=template&id=56f9728c&scoped=true"
import script from "./pk-session-table.vue?vue&type=script&lang=js"
export * from "./pk-session-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f9728c",
  null
  
)

export default component.exports